module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai114-b8eddac266526cf28ae3dcd3dda5a220.jpg";